import { render } from "./list_user_groups.vue?vue&type=template&id=35ded20a&lang=html"
import script from "./list_user_groups.vue?vue&type=script&lang=js"
export * from "./list_user_groups.vue?vue&type=script&lang=js"

import "./list_user_groups.vue?vue&type=style&index=0&id=35ded20a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__